import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Hidden from '@material-ui/core/Hidden';
import withWidth from '@material-ui/core/withWidth';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import withRoot from "../withRoot";
import { connect } from "react-redux";
import Icon from "../components/Header/Icon";
import HeaderLogo from "../components/Header/HeaderLogo";
import HeaderNavigation from "../components/Header/HeaderNavigation";
import DrawerButton from "../components/Header/DrawerButton";
import compose from 'recompose/compose';
import TemporaryDrawer from '../components/Header/TemporaryDrawer';

const styles = {
  root: {
    flexGrow: 1
  },
  flex: {
    flex: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

class Header extends React.Component {
  state = {
    isDrawerOpen: false,
  };

  toggleDrawer = (isOpen) => () => {
    this.setState({
      isDrawerOpen: isOpen,
    });
  };
  
  render() {

  const { classes, user, routesList } = this.props;
  const { isDrawerOpen } = this.state;
  const { toggleDrawer } = this;

  function createInitials() {
    let userInitials = "";
    if (user && user.profile && user.profile.first_name && user.profile.last_name) {
      userInitials = user.profile.first_name.charAt(0) + user.profile.last_name.charAt(0)
    }
    return userInitials;
  }

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          {user && (
            <Hidden mdUp>
              <DrawerButton toggleDrawer={toggleDrawer} menuButton={classes.menuButton}/>
            </Hidden>
          )}
          <div className={classes.flex}>
            <HeaderLogo />
          </div>
          {user && (
            <Hidden smDown>
              <div>
                <HeaderNavigation routes={routesList} />
              </div>
            </Hidden>
          )}
          {user && (
            <div>
              <Icon initials={createInitials()}/>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <TemporaryDrawer routes={routesList} user={user} isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer}/>
    </div>
  );
}
};


Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    routesList: state.general.routes
  };
}


export default withRoot(
  compose(
    withStyles(styles),
    withWidth(),
    connect(mapStateToProps)
  )(Header));



// WEBPACK FOOTER //
// ./src/containers/Header.js